import { computed, reactive, ref } from "vue";
export function useModalState(emit) {
    const modal = ref(undefined);
    const modalState = reactive({
        isSaving: false,
    });
    function open() {
        modal.value?.open();
    }
    function close() {
        modal.value?.close();
    }
    function reset() {
        modalState.isSaving = false;
        resetCbs.forEach(cb => {
            cb();
        });
    }
    const isBusy = computed(() => {
        return modalState.isSaving;
    });
    function modalClosed(e) {
        emit('close', e);
        reset();
    }
    const resetCbs = [];
    function onReset(cb) {
        resetCbs.push(cb);
    }
    return { modal, modalState, open, close, reset, isBusy, modalClosed, onReset };
}
